import './App.css';
import React from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import LayoutResolver from "./components/layout/LayoutResolver";
import AppLayout from "./components/layout/AppLayout";
import { HomeRouter } from "./HomeRouter";
import { ThemeProvider } from './ThemeContext';

import Home from "./components/home/Home";
import ClaimPayout from "./components/payout/ClaimPayout";
import Welcome from "./components/Welcome";
import NotFound from "./components/NotFound";
import { connect } from "react-redux";
import NotFoundLayout from "./components/layout/NotFoundLayout";

function App(props) {
    return (
        <ThemeProvider>
            <Router>
                <React.Suspense fallback={<></>}>
                    <Switch>
                        {/* Payment & payout routes */}
                        <HomeRouter exact layout={AppLayout} path="/pay/:id" component={Home}/>
                        <HomeRouter exact layout={AppLayout} path="/payout/:id/claim" component={ClaimPayout}/>
                        {/* Welcome page — root only */}
                        <LayoutResolver exact layout={NotFoundLayout} path="/" component={Welcome}/>
                        {/* 404 — all other unmatched routes */}
                        <LayoutResolver layout={NotFoundLayout} component={NotFound}/>
                    </Switch>
                </React.Suspense>
            </Router>
        </ThemeProvider>
    );
}

export default connect(null, null)(App);
